var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4014_38634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9715 21.2212L19.2698 17.5195C20.1116 16.2699 20.5269 14.7085 20.3046 13.0447C19.9254 10.2148 17.6061 7.9119 14.7734 7.55327C10.5618 7.02035 7.02033 10.5618 7.55328 14.7734C7.912 17.6073 10.2153 19.9285 13.0455 20.3058C14.7092 20.5281 16.2709 20.113 17.5202 19.2711L21.2219 22.9727C21.7049 23.4558 22.4883 23.4558 22.9713 22.9727C23.4539 22.4891 23.4539 21.7036 22.9715 21.2212ZM9.94609 13.9323C9.94609 11.7496 11.7218 9.97395 13.9044 9.97395C16.0871 9.97395 17.8628 11.7496 17.8628 13.9323C17.8628 16.1149 16.0871 17.8906 13.9044 17.8906C11.7218 17.8906 9.94609 16.1155 9.94609 13.9323Z",
    fill: "url(#paint0_linear_4014_38634)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "url(#paint1_linear_4014_38634)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4014_38634",
    x1: 7.5,
    y1: 15.9453,
    x2: 23.3333,
    y2: 15.9453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4014_38634",
    x1: 1.85023e-8,
    y1: 16,
    x2: 30,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4014_38634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.8333,
    height: 15.8333,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchCircle);
export default __webpack_public_path__ + "static/media/search-circle.3fae3651bd4bf054596c6567bfb3a07a.svg";
export { ForwardRef as ReactComponent };